import { create } from 'zustand';

interface AllFilterState {
  // 필터 패널 표시 여부
  showAllFilters: boolean;

  // 필터 패널 표시/숨김 액션
  setShowAllFilters: (show: boolean) => void;

  // 필터 패널 토글 액션
  toggleAllFilters: () => void;
}

/**
 * 필터 UI 상태를 관리하는 store
 * - 필터 패널의 표시/숨김 상태 관리
 */
export const useAllFilterStore = create<AllFilterState>((set) => ({
  // 초기 상태
  showAllFilters: false,

  // 필터 패널 표시/숨김 설정
  setShowAllFilters: (show: boolean) => set({ showAllFilters: show }),

  // 필터 패널 토글
  toggleAllFilters: () =>
    set((state) => ({ showAllFilters: !state.showAllFilters })),
}));
